import { Phone } from 'lucide-react';

import { EmptyResult } from '@/components/empty-result';

import { useCallsListStore } from '@/store/calls-list.store';

export const CallEmptyResult = () => {
  const { query, reset, filters } = useCallsListStore();

  const hasQuery =
    (query && query.trim() !== '') || filters.status !== 'All' || filters.mode !== 'All';

  return (
    <EmptyResult
      icon={<Phone className="h-12 w-12 text-muted-foreground/40" />}
      title="No call logs found"
      hasQuery={hasQuery}
      description="Adjust or clear filters to view call logs."
      onClear={reset}
    />
  );
};
